module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-4-photo-8-6fcbd63524690df854fe2e903f6c7152.webp";